import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Ui2CheckboxModule } from '@innovation-os-ng/ui/ui2-checkbox';
import { TranslateModule } from '@itonics/ngx-translate-simple';

@Component({
  selector: 'signals-normalize-series',
  templateUrl: './normalize-series.component.html',
  styleUrls: ['./normalize-series.component.scss'],
  standalone: true,
  imports: [CommonModule, Ui2CheckboxModule, TranslateModule, FormsModule]
})
export class NormalizeSeriesComponent {
  public model: boolean;

  @Output()
  changes: EventEmitter<boolean> = new EventEmitter();

  public change() {
    this.changes.emit(this.model);
  }
}
